var module = angular.module('components');
module.component('caMultiselect', {
    templateUrl: 'components/genericcomponents/multiselect.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        model: '=',
        lockChoice: '<',
        choices: '<',
        placeholder: '<',
        itemRenderer: '<',
        orderBy: '<',
        disabledBy: '<'
    },
    controller: ['GenericComponentService',controller]
});


function controller(GenericComponentService)  {
    var vm = this;

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    return;

    function onInit() {
        resolveRenderer();
    }

    function onChanges(changes) {
        if (changes.itemRenderer) {
             resolveRenderer();
        }
    }

    function resolveRenderer() {
        vm.renderItem = GenericComponentService.resolveSelectRenderer(vm.itemRenderer);
    }

}
